module.exports = __webpack_public_path__ + "img/consultant-work.7549ca01.jpg";